import { render, staticRenderFns } from "./orderPrint.vue?vue&type=template&id=b18a6572&scoped=true&"
import script from "./orderPrint.vue?vue&type=script&lang=js&"
export * from "./orderPrint.vue?vue&type=script&lang=js&"
import style0 from "./orderPrint.vue?vue&type=style&index=0&id=b18a6572&scoped=true&lang=css&"
import style1 from "./orderPrint.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b18a6572",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VImg,VRow})
